import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IEmailTemplate, IPlanStatus } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { ColorPicker } from 'primereact/colorpicker';
import { JVDropdown } from "../../shared/JVDropdown";
import { Dropdown } from "primereact/dropdown";

const schema = yup.object({
    noOfDays: yup.number().required("No. Of Day is required").typeError("No. Of Day is required"),
    status_Title: yup.string().required("Status Title is required"),
});

interface Iprops {
    singleData: IPlanStatus,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [color, setColor] = useState<string | null>(null);
    const [colorHEX, setColorHEX] = useState<string>('6466f1');
    const [emailTemplates, setEmailTemplates] = useState<Array<IEmailTemplate>>();
    const [etId, setEtId] = useState(0);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IPlanStatus>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const onColorChange = (e: { value: string }) => {
        setColor(e.value);
    };

    const frequency_Type = [
        { name: 'Monthly' },
        { name: 'Weekly' },
        { name: 'Daily' }
    ]

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: IPlanStatus) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`PlanStatus${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        data.colorPicker = colorHEX;
        saveToDB(data);
    }

    const loadEmailTemplates = async () => {
        const response = await Fetch("Email_Template/emailTemplate", "GET", null, null, null);
        if (response) {
            const data: Array<IEmailTemplate> = await response.json();
            setEmailTemplates(data);
        }
    }

    useEffect(() => {
        loadEmailTemplates();
    }, []);

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit Plan Status" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={1} required label="No. Of Days" control={control} name="noOfDays" error={errors.noOfDays?.message} />
                <JVInput column={1} label="Status Title" control={control} name="status_Title" error={errors.status_Title?.message} />
                <JVDropdown column={1} label="Frequency" control={control} name="planFrequency" options={frequency_Type} optionLabel="name" optionValue="name" placeholder="Select Frequency Type" />

                <JVInput column={1} label="Frequency(Days)" control={control} name="mailSendFrequency" />
                <JVDropdown column={1} label="Email Category" control={control} name="emailTemplateType" options={emailTemplates} optionLabel="template_Name" optionValue="template_Id" placeholder="Select Email Category" />
                {/* <div className="field col-12 md:col-6">
                    <Dropdown options={emailTemplates} optionValue={"template_Id"} optionLabel={"template_Name"} value={etId} onChange={e => setEtId(e.value)} placeholder="Choose Email Template" />
                </div> */}
                <div className="flex-1 flex flex-column align-items-center">
                    <label htmlFor="cp-hex" className="font-bold block mb-2">
                        HEX
                    </label>
                    <ColorPicker inputId="cp-hex" format="hex" value={colorHEX} onChange={(e: any) => setColorHEX(e.value)} className="mb-3" />
                    <span>{colorHEX}</span>
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}